import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { CommentContainer } from "../../../../../../../models/mongodbSchema/aggregates";

@Injectable({providedIn: 'root'})
export class CommentService extends BaseApiTemplateService<CommentContainer>{

    constructor(private http: HttpClient) {
        super()
        this.httpClient = http;
        this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "comment"
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "comment"
        
        this.httpClient = http;
    }

}